import React from 'react';
import { Clock, Phone } from 'lucide-react';
export function AdultClassTimes() {
  return <section className="py-24 bg-off-white" data-id="element-501">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-502">
        <div className="text-center mb-12" data-id="element-503">
          <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-504">
            <Clock className="w-3.5 h-3.5" data-id="element-505" />
            Class Times
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-506">
            Adult Class Times
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-507">
            Two adult-friendly weeknight class slots so you can fit training
            around work and family.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-508">
          <div className="bg-paper border border-subtle-gray rounded-2xl p-6 flex flex-col gap-2" data-id="element-509">
            <div className="flex items-center gap-3" data-id="element-510">
              <div className="w-10 h-10 rounded-xl bg-storm-red/10 flex items-center justify-center text-storm-red" data-id="element-511">
                <Clock className="w-5 h-5" data-id="element-512" />
              </div>
              <div data-id="element-513">
                <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-514">
                  Early Adult Class
                </p>
                <h3 className="text-lg text-ink leading-tight" data-id="element-515">5:00–6:00 PM</h3>
              </div>
            </div>
            <p className="text-gray-warm text-sm pt-1" data-id="element-516">Monday – Friday</p>
          </div>

          <div className="bg-paper border border-subtle-gray rounded-2xl p-6 flex flex-col gap-2" data-id="element-517">
            <div className="flex items-center gap-3" data-id="element-518">
              <div className="w-10 h-10 rounded-xl bg-storm-red/10 flex items-center justify-center text-storm-red" data-id="element-519">
                <Clock className="w-5 h-5" data-id="element-520" />
              </div>
              <div data-id="element-521">
                <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-522">
                  Late Adult Class
                </p>
                <h3 className="text-lg text-ink leading-tight" data-id="element-523">6:00–7:00 PM</h3>
              </div>
            </div>
            <p className="text-gray-warm text-sm pt-1" data-id="element-524">Monday – Friday</p>
          </div>
        </div>

        <div className="bg-ink text-off-white rounded-2xl p-6 flex flex-col md:flex-row items-start md:items-center gap-4 justify-between" data-id="element-525">
          <div data-id="element-526">
            <p className="text-sm uppercase tracking-wide text-storm-red font-bold mb-1" data-id="element-527">
              Not sure which class?
            </p>
            <p className="text-off-white/90" data-id="element-528">
              Tell us your schedule and goals and a coach will recommend the
              best fit before your first visit.
            </p>
          </div>
          <a href="tel:517-220-0621" className="btn-primary shrink-0 flex items-center gap-2" data-id="element-529">
            <Phone className="w-5 h-5" data-id="element-530" />
            Call 517-220-0621
          </a>
        </div>
      </div>
    </section>;
}